/**
 * SPEED wave 1, fix 9 — ONE key and ONE policy for the onboarding-status read.
 *
 * WHY THIS MODULE EXISTS. `onboardingApi.status()` was fetched from six call sites under TWO query
 * keys: five shared `["onboarding-status"]`, and the rail nav item had its own
 * `["onboarding-status", "rail"]`. TanStack Query caches by key, so that was two caches and TWO
 * NETWORK CALLS for one endpoint — and the rail lives in `AdminShell`, so the duplicate was not an
 * edge case, it was every admin page load.
 *
 * Measured before and after with the same script (`onboardingStatusRequests.test.js`):
 * **2 requests per admin page → 1.**
 *
 * THE KEY IS A CONSTANT RATHER THAN A LITERAL so the next consumer cannot invent a seventh variant
 * by typing the array again. That is how the "rail" segment appeared in the first place: nothing was
 * wrong with the code that added it, there was simply nothing to add it TO.
 *
 * ONE HAZARD OF SHARING, NAMED PRECISELY BECAUSE I FIRST NAMED IT WRONG. A co-consumer's
 * `placeholderData` CANNOT affect another observer of this key — it is per-observer in TanStack v5
 * and never enters the cache (a mutant proved it: adding it changed nothing for the rail).
 * `initialData` is the one to refuse: it IS written to the cache, so one consumer's synthetic
 * starting value becomes every consumer's data, and a fail-closed reader like the rail nav item
 * would then show an entry built from a value that never came from the server. No consumer of this
 * key supplies it, and the rail's guard tests red if one ever does.
 *
 * THE STALE WINDOW IS THE RAIL'S, GENERALISED. Its own comment gave the reason — "setup state moves
 * slowly; do not refetch on every rail mount" — and that reasoning was never specific to the rail.
 * An invalidation still refetches immediately (`invalidateQueries` ignores staleness), which is what
 * the onboarding flow relies on after each step completes, so progress still updates the moment it
 * changes.
 */

/** The ONE key every onboarding-status reader uses. Shared cache, one request. */
export const ONBOARDING_STATUS_KEY = ["onboarding-status"];

/**
 * How long a fetched status stays fresh. Five minutes: setup state moves slowly, and the steps that
 * DO move it invalidate the key explicitly rather than waiting for it to go stale.
 */
export const ONBOARDING_STATUS_STALE_MS = 5 * 60 * 1000;

export default ONBOARDING_STATUS_KEY;
